import { useEffect, useContext } from "react"
import { useAsyncReducer } from "../../../hooks/useAsyncReducer"
import { useAuth } from "../../../hooks/useAuth"
import { useStatus } from "../../../hooks/useStatus"
import { useAsyncModal } from "../../../hooks/useAsyncModal"
import { useSyncModal } from "../../../hooks/useSyncModal"
import { CalendarContext } from "../../../contexts/CalendarProvider"
import { InsideContainer } from "../../containers/InsideContainer"
import { Header } from "../../extras/Header"
import { Loading } from "../../static/Loading"
import { EmptyMessage } from "../../static/Messages"
import { ContentBox } from "../../containers/ContentBox"
import { controlReducer, controlInitialState } from "../../../reducers/control"
import { fetchControlData, fetchControlDetail } from "../../../actions/control"
import { ControlRow, TakeAttendance, ControlDetail, AttendanceChart } from "../../views/Control"
import { getCurrentYear, getCurrentMonth } from "../../../utils/calendar"

export const ControlView = () => {
    const [{ loadStatus }, handleStatus] = useStatus()
    const [loading, state, dispatch] = useAsyncReducer(controlReducer, controlInitialState, handleStatus)
    const [user] = useAuth()
    const [calendar] = useContext(CalendarContext)

    const month = calendar.month
    const year = getCurrentYear(calendar.years, calendar.month)

    useEffect(() => {
        if(!loadStatus)
            dispatch(fetchControlData(user.token, month, year))
    //eslint-disable-next-line
    }, [loadStatus])

    const [open] = useSyncModal()
    const [,setDetailId] = useAsyncModal('control', fetchControlDetail, ControlDetail.Body, ControlDetail.Header)

    const handleTakeAttendance = () => open(TakeAttendance.Header, TakeAttendance.Body)
    const handleInfo = (uuid) => setDetailId(uuid)

    const eventHandlers = { onInfo: handleInfo }

    return (
        <InsideContainer reducerContext={[loading, state, dispatch, user]}>
            <div className="uk-width-2-3@m om-padding-remove@s">
                <Header buttonIcon="fas fa-user-edit" buttonText="Pasar Lista" onClick={handleTakeAttendance}>
                    <i className="fa fa-1x fa-users"></i> Asistencia
                </Header>
                <h3 className="uk-text-bold uk-text-center uk-margin-remove-top">
                    <i className="fas fa-clipboard-list"></i> Controles de asistencia en {getCurrentMonth(month)}
                </h3>
                {state.error ? <EmptyMessage message={state.error}/> :
                loading && !state.controls ? <Loading large={false}/> :
                !state.controls || state.controls.length === 0 ? <EmptyMessage message="No se han encontrado datos."/> :
                <ContentBox loading={loading} error={state.error} list={state.controls}
                    component={ControlRow} eventHandlers={eventHandlers} gap={'20px'}
                    emptyMessage={'No se han encontrado datos.'}
                />}
                <p className="uk-text-lead uk-text-justify hide-s">
                    <b>RECUERDA</b>: En esta lista sólo se muestran los eventos de este mes, para ver otros meses tendrás que cambiar de mes desde la página de calendario.
                </p>
            </div>
            <div className="uk-width-1-3@m uk-text-center hide-s">
                <h3><i className="fas fa-chart-pie"></i> Asistencia en el último mes</h3>
                <hr/>
                <AttendanceChart controls={state.controls}/>
                <p className="uk-text-justify">Estas estadísticas son sólo aproximaciones, en ningún caso podrán ser utilizadas con ningún carácter.</p>
            </div>
        </InsideContainer>
    )
}